<div class="form-group">
    <label class="input-label">Rows:</label>
    <input type="number"
           name="fieldOptions.numRows"
           value="{{fieldOptions.numRows}}"
           min="1"
           max="100"
           (change)="recalculateTable()"
           [(ngModel)]="fieldOptions.numRows"
           (ngModelChange)="dataChangedEvent($event)"
           class="form-control">
</div>
<div class="form-group">
    <label class="input-label">Columns:</label>
    <input type="number"
           min="1"
           max="100"
           name="fieldOptions.numCols"
           value="{{fieldOptions.numCols}}"
           (change)="recalculateTable()"
           [(ngModel)]="fieldOptions.numCols"
           (ngModelChange)="dataChangedEvent($event)"
           class="form-control">
</div>